import {FC} from "react";
import {TransactionMainComponent} from "../../../components";
import {DailyTransactionTypeEnum, PageEnum} from "../../../models";

export const SalesInvoicePage: FC = ({}) => {
    //#region html
    return (
        <>
            <TransactionMainComponent
                formId={PageEnum.SalesInvoice}
                transactionType={DailyTransactionTypeEnum.SalesInvoice}
            />
        </>
    );
    //#endregion
};
